<template>
	<section
		class="sign_up"
		:class='[theme, layout_choice]'
	>
		<div class="container">
			<div class='content'>
				<h2
					v-if='title'
					v-html='title'
					:class="{'has-text': text}"
				></h2>
				<div
					class="sign_up__inner"
					v-if='text'
					v-html='text'
				></div>
			</div>

			<slot></slot>

		</div>

		<svg
			v-if="theme === 'dark'"
			xmlns="http://www.w3.org/2000/svg"
			width="341.908"
			height="250"
			viewBox="0 0 341.908 250"
		>
			<path
				id="Path_901"
				data-name="Path 901"
				d="M249.2,12.518h92.707v250H0Z"
				transform="translate(0 -12.518)"
				fill="#16191d"
			/>
		</svg>

	</section>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		section_id: {},
		top_border: {},
		text: {},
		primary_cta: {},
		title: {},
		theme: {},
		layout_choice: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {
		let textIcons = document.querySelectorAll('.text_icon');

		textIcons.forEach((element) => {
			window.onscroll = function () {
				var theta = (document.documentElement.scrollTop / 100) % Math.PI;

				element.style.transform = 'rotate(' + theta + 'rad)';
			};
		});
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.sign_up {
	background: var(--emerald);
	padding: 64px 0;

	.container {
		.content {
			grid-column: span 4;

			h2 {
				color: var(--midnight);
				margin-top: 0;
				margin-bottom: 0;

				&.has-text {
					margin-bottom: 24px;
				}
			}

			.sign_up__inner {
				&::v-deep {
					p {
						color: var(--midnight);
					}
				}
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
				margin-bottom: 24px;
			}
		}

		> span {
			display: flex !important;
			grid-column: 6 / span 7;
			justify-content: flex-start;
			align-items: center;

			> .gform_wrapper {
				width: 100% !important;
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;

				> .gform_wrapper {
					width: 100% !important;
				}
			}
		}

		.mc4wp-form {
			.mc4wp-form-fields {
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 24px;

				.half {
					grid-column: span 1;

					> label {
						display: none;
					}
				}

				.full {
					grid-column: span 2;

					> label {
						display: none;
					}
				}

				input {
					width: calc(100% - 32px);
					appearance: none;
					border: 0;
					margin: 0;
					padding: 0 16px;
					height: 48px;
					font: normal normal normal 16px/24px var(--primary-font-family);
					color: var(--emerald);
					outline: none;
					border: 1px solid transparent;

					&[type='checkbox'] {
						&:hover {
							cursor: pointer;
						}
					}

					&:checked {
						position: relative;

						&::before {
							content: '\2713';
							position: absolute;
							top: -1px;
							left: 2px;
							line-height: 15px;
							font-weight: bold;
							font-size: 11px;
							/* width: 10px;
							height: 10px; */
							color: var(--midnight);
							/* background: var(--midnight); */
						}
					}

					&::placeholder {
						font: normal normal normal 16px/24px var(--primary-font-family);
						color: var(--emerald);
					}

					&.wpforms-error {
						border: 1px solid var(--critical);
					}

					&[type='submit'] {
						display: inline-flex;
						padding: 0 16px;
						border: 2px solid var(--midnight);
						border-radius: 20px;
						background: transparent;
						text-decoration: none;
						height: 36px;
						display: inline-flex;
						justify-content: center;
						align-items: center;
						transition: 0.2s ease background;
						color: var(--white);
						width: auto;

						@media (hover) {
							&:hover {
								background: var(--midnight);
								transition: 0.2s ease all;
								cursor: pointer;
								color: var(--dark-charcoal);
							}
						}

						&:disabled {
							opacity: 0.5;
						}
					}
				}

				fieldset {
					border: 0;
					margin: 0;
					padding: 0;
					grid-column: span 2;

					legend {
						font: normal normal 500 16px/20px var(--primary-font-family);
						color: var(--white);
						margin-bottom: 24px;
					}

					ul {
						list-style: none;
						padding: 0;
						columns: 4;
						gap: 24px;
						display: grid;
						grid-template-columns: 1fr 1fr 1fr 1fr;

						@media (max-width: $mobile-xl) {
							grid-template-columns: 1fr 1fr;
						}

						@media (max-width: $mobile-xl) {
							columns: 2;
						}

						li {
							align-items: flex-start;
							display: grid;
							grid-template-columns: 16px 1fr;
							align-items: flex-start;
							gap: 8px;

							input {
								width: 16px;
								height: 16px;
								border: 1px solid var(--midnight);
								display: flex;
								padding: 2px;
							}

							label {
								color: var(--white);
								font: normal normal normal 14px/18px var(--primary-font-family);
							}

							&.wpforms-selected {
								input {
									background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI3IiB2aWV3Qm94PSIwIDAgOSA3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNOC43NTAxMiAxLjYwMDQ5TDMuOTQxNzkgNi40MDg4MkwwLjk4NjA4NCAzLjQ1MzExTDIuNDAwMyAyLjAzODlMMy45NDE3OSAzLjU4MDM5TDcuMzM1OSAwLjE4NjI3OUw4Ljc1MDEyIDEuNjAwNDlaIiBmaWxsPSIjMDBBRUVGIi8+Cjwvc3ZnPgo=');
									background-size: 10px 10px;
									background-repeat: no-repeat;
									background-position: center center;
								}
							}
						}
					}
				}
			}
		}

		.wpforms-container {
			.wpforms-field {
				width: 100%;

				fieldset {
					border: 0;
					margin: 0;
					padding: 0;

					legend {
						font: normal normal 500 16px/20px var(--primary-font-family);
						color: var(--white);
						margin-bottom: 24px;
					}

					ul {
						list-style: none;
						padding: 0;
						columns: 4;
						gap: 24px;

						@media (max-width: $mobile-xl) {
							columns: 2;
						}

						li {
							display: flex;
							gap: 8px;
							margin-bottom: 16px;
							align-items: center;

							input {
								width: 16px;
								height: 16px;
								border: 1px solid var(--midnight);
								display: flex;
								padding: 2px;
							}

							label {
								color: var(--white);
								font: normal normal normal 14px/18px var(--primary-font-family);
							}

							&.wpforms-selected {
								input {
									background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI3IiB2aWV3Qm94PSIwIDAgOSA3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNOC43NTAxMiAxLjYwMDQ5TDMuOTQxNzkgNi40MDg4MkwwLjk4NjA4NCAzLjQ1MzExTDIuNDAwMyAyLjAzODlMMy45NDE3OSAzLjU4MDM5TDcuMzM1OSAwLjE4NjI3OUw4Ljc1MDEyIDEuNjAwNDlaIiBmaWxsPSIjMDBBRUVGIi8+Cjwvc3ZnPgo=');
									background-size: 10px 10px;
									background-repeat: no-repeat;
									background-position: center center;
								}
							}
						}
					}
				}
			}

			#wpforms-error-noscript {
				display: none;
			}

			.wpforms-field-container {
				display: grid;
				grid-template-rows: auto auto;
				gap: 24px;
			}

			.wpforms-submit-container {
				margin-top: 24px;
				display: flex;
				flex-wrap: wrap;
				align-items: center;

				.wpforms-hidden {
					display: none;
				}

				.wpforms-submit-spinner {
					margin-left: 8px;
				}

				button {
					display: inline-flex;
					padding: 0 16px;
					border: 2px solid var(--midnight);
					border-radius: 20px;
					background: transparent;
					text-decoration: none;
					height: 36px;
					display: inline-flex;
					justify-content: center;
					align-items: center;
					transition: 0.2s ease background;
					color: var(--white);

					@media (hover) {
						&:hover {
							background: var(--midnight);
							transition: 0.2s ease all;
							cursor: pointer;
							color: var(--dark-charcoal);
						}
					}

					&:disabled {
						opacity: 0.5;
					}
				}
			}

			.wpforms-label-hide {
				display: none;
			}

			input {
				width: calc(100% - 32px);
				appearance: none;
				border: 0;
				margin: 0;
				padding: 0 16px;
				height: 48px;
				font: normal normal normal 16px/24px var(--primary-font-family);
				color: var(--emerald);
				outline: none;
				border: 1px solid transparent;

				&::placeholder {
					font: normal normal normal 16px/24px var(--primary-font-family);
					color: var(--emerald);
				}

				&.wpforms-error {
					border: 1px solid var(--critical);
				}
			}

			.wpforms-field-layout-rows {
				.wpforms-layout-row {
					display: grid;
					grid-template-columns: 1fr 1fr;
					margin: 0;
					gap: 24px;

					.wpforms-layout-column {
						padding: 0;
						width: 100%;
					}
				}
			}
		}
	}
}
</style>
